import { useEffect, useState } from 'react';
import {
    Box,
    Typography,
} from '@mui/material';
import DataTable from '../../components/DataTable';
import ApiService from '../../services/api';
import Layout from '../../components/Layout';
import { UserProfile } from '../../types';
import { useAppContext } from '../../context/AppContext';

const UserDetails = () => {
    const { token, setToken, setUserId, userProfilesCache, getTranslation } = useAppContext();
    const [profileData, setProfileData] = useState<UserProfile[]>([]);

    useEffect(() => {
        const handleSubmit = (): void => {
            // Get token from context
            if (!token) {
                console.error('No authentication token found');
                setProfileData([]);
                return;
            }

            // Use data from global store instead of calling API
            if (!userProfilesCache.data) {
                console.error('No user profile data found in store');
                setProfileData([]);
                return;
            }

            const userData = userProfilesCache.data as any;
            
            // Extract userId from user profile - userId is in _id field
            let userId = '';
            if (userData && userData.user && userData.user.user && userData.user.user._id) {
                userId = userData.user.user._id;
            } else if (userData && userData.user && userData.user._id) {
                userId = userData.user._id;
            } else if (userData && userData._id) {
                userId = userData._id;
            } else {
                console.error('No userId found in user profile');
                setProfileData([]);
                return;
            }



            // Now call getAllUserSessions with the extracted userId
            const api = new ApiService(null, token);
            api.getAllUserSessions(userId)
                .then((data: any) => {
                    if (!data) return;
                    
                    // Handle the nested sessions response structure
                    if (data && data.data && Array.isArray(data.data.sessions)) {
                        // Pass session data directly without transformation
                        setProfileData(data.data.sessions);
                    } else if (Array.isArray(data)) {
                        setProfileData(data);
                    } else if (data && Array.isArray(data.data)) {
                        setProfileData(data.data);
                    } else {
                        setProfileData([]);
                    }
                })
                .catch((err) => {
                    if (err.message?.includes('Authentication token is required') || 
                        err.message?.includes('Unauthorized') ||
                        err.statusCode === 401) {
                        setToken(null);
                        setUserId(null);
                    }
                    // Set empty array on error to prevent map error
                    setProfileData([]);
                });
        };
        handleSubmit();
    }, [userProfilesCache.data, token]);

    return (
        <Layout showBackButton={true}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: "50px", md: "100px" },
                    alignItems: { xs: "center", md: "center" },
                    justifyContent: { xs: "space-between", md: "center" },
                    // height: "90vh",
                    padding: "30px",
                }}>
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: "20px", md: "100px" },
                    alignItems: { xs: "center", md: "center" },
                    justifyContent: { xs: "center", md: "center" },
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: { xs: "60px", md: '30px' },
                    }}>
                        <Typography sx={{
                            color: "var(--color-text-primary)",
                            textAlign: "center",
                            fontFamily: "HerbalifeFont",
                            fontSize: "30px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "13px",
                            paddingBottom: "30px"
                        }}>
                               {getTranslation("Txt284")}
                        </Typography>

                        <DataTable profileData={profileData} />
                    </Box>
                </Box>
            </Box>
        </Layout>
    );
};

export default UserDetails;
